"use client";

import { useEffect, ReactNode } from "react";

import { removeOrganiserPassedFlag } from "@/utils/session.utils";

interface SessionFlagProviderProps {
  children: ReactNode;
}

export default function SessionFlagProvider({
  children,
}: SessionFlagProviderProps) {
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Only clear on page refresh/browser close, NOT navigation
      removeOrganiserPassedFlag();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return children;
}
